import { useAppSelector } from '@/store/stores'
import {
  selectInterfaces,
  selectInterfacesByOrganization,
  selectPermissionLoading,
} from '@/store/selectors/UserSelector'
import { usePermissionAccess } from '@/features/auth/hooks/usePermissionAccess'

/**
 * @desc:
 * to be refactored: remove this file and use directly the selectors
 */
const usePermission = () => {
  const interfaces = useAppSelector(selectInterfaces)
  const interfacesByOrganization = useAppSelector(
    selectInterfacesByOrganization,
  )
  const isLoading = useAppSelector(selectPermissionLoading)

  const { isViewOnly, isAccessControlLoading, isLoadingMyAccessControl } =
    usePermissionAccess()

  return {
    interfaces,
    interfacesByOrganization,
    isViewOnly,
    isLoading: isLoading || isLoadingMyAccessControl,
    isAccessControlLoading,
  }
}

export default usePermission
